const envTokin = window.__env || {};

// this is whatever your component edge war is called, with a trailing slash
envTokin.baseUrl = 'tokin/';
// whether to enable the Angular debugging provider
envTokin.enableDebug = true;
// the language to use on Component Edge front end
envTokin.language = 'JAPANESE';
envTokin.intellidataApiUrl = 'https://testapi.kemet.com:7557/gateway/IntelliData-Search/1.0/';
envTokin.documentationUrl = 'https://testapi.kemet.com:7557/gateway/IntelliData-ComponentDocumentation/1.0/';
envTokin.datasheetUrl = 'http://idaz-dev-web-01.kemet.com/datasheets/';
envTokin.visualSearchFreshness = '05-15-2020'; // this is a time stamp to automatically expire the new badge.
export default envTokin;
